import React from 'react';
import { ImportReferenceTypeEditTemplate } from 'themes/application/import-reference-type/pages';
import { observer } from 'mobx-react';
import { ImportReferenceTypeEditViewStore } from 'application/import-reference-type/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ImportReferenceTypeEditViewStore(rootStore), 'editView')
@observer
class ImportReferenceTypeEdit extends React.Component {
    render() {
        return <ImportReferenceTypeEditTemplate {...this.props} />
    }
}

export default ImportReferenceTypeEdit;
